import React from "react";

export const IconAddPlus = (props?: { iconFill?: string, className?: string, defs?: React.ReactNode, stroke?: string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            className={props?.className}
        >
            { props?.defs ? props.defs : null }
            <path fill={ props?.iconFill } stroke={ props?.stroke } d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m7 14h-5v5h-4v-5H5v-4h5V5h4v5h5z"></path>
        </svg>
    )
};

export default IconAddPlus;
